import React,{useEffect} from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import swal from 'sweetalert';
import { salesforceSendFormNumber } from '../actions/StudentAction';
import { StateUseContext } from '../context/UserDetailContext';


const PayFortReturn = () => {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const {userDetail} = StateUseContext();
    const {form_num} = userDetail !==undefined && userDetail
    const searchParams = new URLSearchParams(location.search);

    const remark = searchParams.get("remark");
  

    useEffect(()=>{
      if(params.status === 'success'){
        salesforceSendFormNumber({form_num:form_num,status:'payment_approved'})
        swal('Congratulations Your fee submitted successfully.','','success')
        navigate('/student/dashboard');
      }
      else{
        salesforceSendFormNumber({form_num:form_num,status:'payment_rejected'})

        remark ? swal(remark,'Your payment is failed please try again.','error') 
        : swal('Your payment is failed please try again.','','error')
          
          navigate('/student/dashboard');
      }
  })
  return (
    <div></div>
  )
}

export default PayFortReturn